import React, { useState, useEffect, useRef } from 'react';
import './FadeInSectionLeftToRight.css';

const FadeInSectionLeftToRight = ({ children }) => {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                setVisible(entry.isIntersecting);
            });
        });

        const { current } = domRef;
        observer.observe(current);

        return () => {
            observer.unobserve(current);
        };
    }, []);

    return (
        <div
            className={`fade-in-section-left-to-right ${isVisible ? "is-visible-left-to-right" : ""}`}
            ref={domRef}
        >
            {children}
        </div>
    );
};

export default FadeInSectionLeftToRight;
